module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAZCAYAAAAxFw7TAAAAAXNSR0IArs4c6QAAAQpJREFUSEvtlT1Lw1AUhp+TFKRUHDoWXJ2kg4s/QdB+TFkFnVxNF9Mf0DuZ1alQcMxUQgV/gksHcXJUcHQQpQ5NjyR0cAgpV7IIOdvh3vvAOee97xHSODEDXHygleX28UZCyCy4FvrmEiW0Z+S8EHyhZ16AXZQvhDuQxA6uLsoxQgN4TYGaAZRb4uDUDra+3TFjHM7T7BdQJsRXZ38C9swNcFEBqx7a6KeSzfov/yvZ9EeHrJwjVCR32KKKs7pnOnzIzgun7Hku3wfvCDsblPPB1rxJFCXFwNTSuqNHRPYLgcoTcdDOnHSjDr2wzuJzj5qbX/IyUerbz0T+oqDk8hy75J1S+tYreS//ANHWxNJa3k/aAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/enroll-phone.png
// module id = 64xM
// module chunks = 1